import { ObjectType } from "../interfaces/intakes.reports";
import { capitalize } from "./eliminarEs";

export const jsonToArraySelect = (json:ObjectType):string[] => {
  const array = [];
  for (const key in json) {
    if (json.hasOwnProperty(key)) {
      array.push(key);
    }
  }
  return array;
}

export const jsonKeyToString = ( key:string ):string => {

  const names:ObjectType = {
    "pallet_ref": "Pallet Ref.",
    "extra_ref": "Extra Ref.",
    "kilos": "Total kilos",
    "gln_ggn": "GLN/GGN",
    "variety_ies_": "Variety/ies",
    "variety_ies": "Variety/ies",
    "variety(ies)": "Varieties",
    "gln_ggn_number": "GLN/GGN number",
    "gln": "GLN",
    "ggn": "GGN",
    "coc": "CoC",
    "delivery_note_awb_number": "Delivery note/AWB Nº",
    "type_gps_tracker": "Type GPS tracker",
    "temperature": "Temperature °C",

    //Labels
    "name_weight": "Name & Weight",
    "ean_code": "EAN Code",

    //Appearance
    "temperature_c": "Temperature °C",

    //Pallgrow
    "dust_sand": "Dust/Sand",
    "ltd": "LTD",
    "juicing_exudated_berry": "Juicing/Exudated berry",
    "russet_scar": "Russet/Scar",
    "shrivelling_heavy": "Shrivelling (Heavy)",
    "wet_open_berries": "Wet/Open Berries",
    "brown_heart_cavities": "Brown Heart/Cavities"
  }

  return names[key] ? names[key] : capitalize(key.split("_").join(" "));
}